<template>
    <!-- Top bar -->
    <div class="nav-bar-maintenance">
      <img
        src="@/assets/logogruas.png"
        alt="HomePage"
        @click="backMainPanel"
        class="logo-button"
      />
    </div>
  
    <!-- Page -->
    <main class="page">
      <!-- Header -->
      <header class="page-header">
        <div>
          <h2>Unidades</h2>
          <p class="subtitle">Tabla de unidades con filtros por columna.</p>
        </div>
  
        <button v-if="canCreateUnit" @click="addUnit" class="btn btn-primary">
          Agregar nueva unidad
        </button>
      </header>
  
      <!-- TABLE SECTION (NO CARD) -->
      <section class="table-section">
        <!-- Section header -->
        <div class="table-head">
          <h3>Tabla de unidades</h3>
  
          <div class="meta">
            <span class="chip">Total: <b>{{ n_units }}</b></span>
            <span class="chip">Página <b>{{ currentPage }}</b> / <b>{{ totalUnitsPages }}</b></span>
          </div>
        </div>
  
        <!-- Table -->
        <div v-if="!canViewTable" class="no-access">
          No tienes permisos para ver el listado de unidades.
        </div>
        <div v-else class="table-wrap">
          <table class="table">
            <colgroup>
    <col style="width: 100px" />   <!-- ID -->
    <col style="width: 110px" />  <!-- Económico -->
    <col style="width: 180px" />  <!-- Propietario -->
    <col style="width: 110px" />  <!-- Placas -->
    <col style="width: 170px" />  <!-- Serie (ENGINE SERIAL) -->
    <col style="width: 120px" />  <!-- Marca -->
    <col style="width: 160px" />  <!-- SubMarca -->
    <col style="width: 90px" />   <!-- Modelo -->
    <col style="width: 110px" />  <!-- Clase -->
    <col style="width: 130px" />  <!-- Tipo -->
    <col style="width: 150px" />  <!-- Categoría -->
    <col style="width: 120px" />  <!-- Estatus -->
  </colgroup>
            <thead>
              <!-- Column titles -->
              <tr class="head-row">
                <th>ID</th>
                <th>Económico</th>
                <th>Propietario</th>
                <th>Placas</th>
                <th>Serie</th>
                <th>Marca</th>
                <th>SubMarca</th>
                <th>Modelo</th>
                <th>Clase</th>
                <th>Tipo</th>
                <th>Categoría</th>
                <th>Estatus</th>
              </tr>
  
              <!-- Filters -->
              <tr class="filter-row">
                <th><input v-model="filters.unit_id" @input="applyFiltersUnit" placeholder="Buscar ID" /></th>
                <th><input v-model="filters.unit_short_id" @input="applyFiltersUnit" placeholder="Buscar # económico" /></th>
                <th><input v-model="filters.unit_owner" @input="applyFiltersUnit" placeholder="Buscar propietario" /></th>
                <th><input v-model="filters.unit_plates" @input="applyFiltersUnit" placeholder="Buscar placas" /></th>
                <th><input v-model="filters.unit_engine_num" @input="applyFiltersUnit" placeholder="Buscar serie motor" /></th>
                <th><input v-model="filters.unit_brand" @input="applyFiltersUnit" placeholder="Buscar marca" /></th>
                <th><input v-model="filters.unit_sub_brand" @input="applyFiltersUnit" placeholder="Buscar submarca" /></th>
                <th><input v-model="filters.unit_model" @input="applyFiltersUnit" placeholder="Buscar modelo" /></th>
                <th><input v-model="filters.unit_class" @input="applyFiltersUnit" placeholder="Buscar clase" /></th>
                <th><input v-model="filters.unit_type" @input="applyFiltersUnit" placeholder="Buscar tipo" /></th>
                <th><input v-model="filters.unit_category" @input="applyFiltersUnit" placeholder="Buscar categoría" /></th>
                <th><input v-model="filters.unit_status" @input="applyFiltersUnit" placeholder="Buscar estatus" /></th>
              </tr>
            </thead>
  
            <tbody>
              <tr
                v-for="(unit, index) in paginatedUnits"
                :key="index"
                class="row"
                @click="viewUnitDetails(unit.unit_id)"
                title="Click para ver detalles"
              >
                <td><span class="id-pill">{{ unit.unit_id }}</span></td>
                <td class="mono">{{ unit.unit_short_id }}</td>
                <td>{{ unit.unit_owner }}</td>
                <td class="mono">{{ unit.unit_plates }}</td>
                <td class="mono">{{ unit.unit_engine_num }}</td>
                <td>{{ unit.unit_brand }}</td>
                <td>{{ unit.unit_sub_brand }}</td>
                <td class="mono">{{ unit.unit_model }}</td>
                <td>{{ unit.unit_class }}</td>
                <td>{{ unit.unit_type }}</td>
                <td>{{ unit.unit_category }}</td>
                <td>
                  <span
                    class="status"
                    :class="{
                      'is-available': unit.unit_status === 'Disponible',
                      'is-service': unit.unit_status === 'En servicio'
                    }"
                  >
                    {{ unit.unit_status }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
  
        <!-- Pagination -->
        <div class="pagination">
          <button class="icon-btn" @click="prevPage" :disabled="currentPage === 1">
            <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
          </button>
  
          <div class="pages">
            <span
              v-for="pageNumber in totalUnitsPages"
              :key="pageNumber"
              @click="goToPage(pageNumber)"
              class="page-pill"
              :class="{ active: pageNumber === currentPage }"
            >
              {{ pageNumber }}
            </span>
          </div>
  
          <button class="icon-btn" @click="nextPage" :disabled="currentPage >= totalUnitsPages">
            <img src="@/assets/angulo-derecho.png" alt="Next Page" />
          </button>
        </div>
      </section>
    </main>
  </template>
  
<style scoped>
  :root{
    --bg: #f6f7f9;
    --surface: #ffffff;
    --surface-2: #fbfbfc;
    --border: #e3e6ea;
    --text: #1f2937;
    --muted: #6b7280;
    --shadow: 0 10px 25px rgba(0,0,0,.08);
    --radius: 16px;
    --brand: #FFC434;
    --brand-soft: rgba(255,196,52,.22);
  }
  
  *{ box-sizing: border-box; }
  body{
    margin: 0;
    background: var(--bg);
    color: var(--text);
    font-family: system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Ubuntu,"Helvetica Neue",Arial;
  }
  
  /* top bar */
  .nav-bar-maintenance{
    position: fixed;
    top: 0; left: 0;
    width: 100vw;
    height: 64px;
    background-color: var(--brand);
    z-index: 1000;
  }
  .logo-button{
    position: absolute;
    height: 80%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
  }
  
  /* page */
  .page{
    max-width: 1600px;
    margin: 0 auto;
    padding: 86px 16px 24px;
  }
  
  .page-header{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 12px;
    margin-bottom: 12px;
  }
  .page-header h2{
    margin: 0;
    font-size: 22px;
    font-weight: 900;
  }
  .subtitle{
    margin: 6px 0 0;
    font-size: 13px;
    color: var(--muted);
  }
  
  /* button */
  .btn{
    border: 1px solid var(--border);
    background: var(--surface);
    color: var(--text);
    padding: 10px 14px;
    border-radius: 14px;
    font-weight: 800;
    font-size: 13px;
    cursor: pointer;
    transition: transform .06s ease, filter .15s ease;
  }
  .btn:active{ transform: translateY(1px); }
  
  .btn-primary{
    background: linear-gradient(180deg, #FFD36B 0%, #FFC434 100%);
    border-color: rgba(0,0,0,.12);
    color: #151515;
    box-shadow: 0 10px 20px rgba(255,196,52,.18);
  }
  .btn-primary:hover{ filter: brightness(.97); }
  
  /* card */
  .card{
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    box-shadow: var(--shadow);
    overflow: hidden;
  }
  .card-head{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 14px;
    border-bottom: 1px solid var(--border);
  }
  .card-head h3{
    margin: 0;
    font-size: 15px;
    font-weight: 900;
  }
  .meta{
    display: flex;
    gap: 8px;
  }
  .chip{
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
    padding: 6px 10px;
    border-radius: 999px;
    font-size: 12px;
  }
  
  /* table */
  .table-wrap{
    overflow: auto;
    max-height: calc(100vh - 230px); /* keeps pagination visible; scroll table */
  }
  .table{
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 13px;
  }
  
  .table thead th{
    padding: 10px 10px;
    text-align: left;
    border-bottom: 1px solid var(--border);
    white-space: nowrap;
  }
  
  .head-row th{
    position: sticky;
    top: 0;
    z-index: 3;
    background: #f3f4f6;
    color: var(--muted);
    font-size: 12px;
    font-weight: 900;
    letter-spacing: .3px;
  }
  
  .filter-row th{
    position: sticky;
    top: 40px; /* sits under header row */
    z-index: 2;
    background: #ffffff;
    padding-top: 8px;
    padding-bottom: 10px;
  }
  
  .table thead input{
    width: 100%;
    height: 36px;
    padding: 0 10px;
    border-radius: 12px;
    border: 1px solid #d7dbe0;
    outline: none;
    font-size: 13px;
    background: #fff;
  }
  .table thead input:focus{
    border-color: rgba(255,196,52,.9);
    box-shadow: 0 0 0 3px rgba(255,196,52,.22);
  }
  
  .table tbody td{
    padding: 12px 10px;
    border-bottom: 1px solid rgba(227,230,234,.9);
    vertical-align: middle;
    max-width: 220px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .row{ cursor: pointer; }
  .row:hover td{ background: #fafafa; }
  
  .mono{ font-variant-numeric: tabular-nums; }
  
  .id-pill{
    display: inline-flex;
    padding: 6px 10px;
    border-radius: 999px;
    background: var(--brand-soft);
    border: 1px solid rgba(255,196,52,.35);
    font-weight: 900;
    color: #111827;
  }
  
  /* status */
  .status{
    display: inline-flex;
    padding: 6px 10px;
    border-radius: 999px;
    border: 1px solid #e5e7eb;
    background: #f3f4f6;
    font-size: 12px;
    font-weight: 800;
  }
  .status.is-available{
    background: rgba(16,185,129,.12);
    border-color: rgba(16,185,129,.28);
    color: #065f46;
  }
  .status.is-service{
    background: rgba(239,68,68,.12);
    border-color: rgba(239,68,68,.28);
    color: #7f1d1d;
  }
  
  /* pagination */
  .pagination{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 12px 14px;
    border-top: 1px solid var(--border);
    background: #fff;
  }
  
  .icon-btn{
    width: 42px;
    height: 42px;
    border-radius: 14px;
    border: 1px solid var(--border);
    background: var(--surface);
    display: grid;
    place-items: center;
    padding: 0;
    cursor: pointer;
    flex: 0 0 auto;
  }
  .icon-btn:disabled{ opacity: .45; cursor: not-allowed; }
  .icon-btn img{ width: 20px; height: 20px; object-fit: contain; display: block; }
  
  .pages{
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 70vw;
  }
  .page-pill{
    user-select: none;
    cursor: pointer;
    padding: 8px 10px;
    border-radius: 12px;
    border: 1px solid var(--border);
    background: #fff;
    font-size: 12px;
    font-weight: 800;
  }
  .page-pill.active{
    background: rgba(255,196,52,.25);
    border-color: rgba(255,196,52,.45);
  }

  /* =========================
   DESKTOP TABLE READABILITY FIX
   ========================= */

/* Give the grid enough intrinsic width so columns don't get squeezed */
.table{
  table-layout: auto;       /* important: avoid fixed squeezing */
  min-width: 1500px;        /* adjust if you want wider/narrower */
}

/* Stop truncating EVERY column */
.table tbody td{
  max-width: none;
  white-space: normal;      /* allow wrapping for long values */
  overflow: visible;
  text-overflow: clip;
  line-height: 1.25;
}

/* Keep only "short" columns in one line (optional but recommended) */
.table tbody td:nth-child(1),  /* ID */
.table tbody td:nth-child(2),  /* Económico */
.table tbody td:nth-child(4),  /* Placas */
.table tbody td:nth-child(5),  /* Serie */
.table tbody td:nth-child(8)   /* Modelo */
{
  white-space: nowrap;
}

/* Make the header/filter row match the new behavior */
.table thead th{
  white-space: nowrap;
}

/* Filters should remain tidy */
.table thead input{
  white-space: nowrap;
}

/* Slightly bigger text for desktop comfort */
.table{
  font-size: 13px;
}
/* =========================
   HARD FIX: prevent “one-letter-per-line”
   (overrides any global/old rules)
   ========================= */
   .table{
  table-layout: fixed;          /* works with colgroup widths */
  min-width: 1530px;            /* sum of col widths approx */
}

.table th,
.table td{
  width: auto !important;       /* overrides old width:8% rules */
  white-space: nowrap;          /* keep words on one line */
  word-break: normal !important;
  overflow-wrap: normal !important;
}

.table tbody td{
  overflow: hidden;
  text-overflow: ellipsis;      /* nice truncation */
}

/* allow ONLY owner to wrap if you want */
.table tbody td:nth-child(3){
  white-space: normal;          /* propietario can wrap */
  line-height: 1.25;
}

/* make the table scroll horizontally instead of crushing */
.table-wrap{
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* =========================
   HARD RESET: enforce real table layout
   (fixes global display:flex/block rules)
   ========================= */
   .table-wrap table.table { display: table !important; }
.table-wrap thead { display: table-header-group !important; }
.table-wrap tbody { display: table-row-group !important; }
.table-wrap tr { display: table-row !important; }
.table-wrap th,
.table-wrap td { display: table-cell !important; }

/* keep it readable */
.table-wrap th,
.table-wrap td{
  white-space: nowrap !important;
  word-break: normal !important;
  overflow-wrap: normal !important;
  vertical-align: middle !important;
}

/* optional: allow propietario to wrap */
.table-wrap td:nth-child(3){
  white-space: normal !important;
  line-height: 1.25;
}

/* ensure columns don't collapse */
.table-wrap .table{
  table-layout: fixed !important;
  min-width: 1530px;
}

/* =========================
   NO SCROLL (H + V) — FIT TO SCREEN
   ========================= */
   .table-wrap{
  overflow: visible !important;
  max-height: none !important;
}

.table-wrap .table{
  width: 100% !important;
  min-width: 0 !important;
  table-layout: fixed !important;
}

/* allow content to wrap so we don’t need horizontal scroll */
.table-wrap th,
.table-wrap td{
  white-space: normal !important;
  word-break: break-word !important;
  overflow-wrap: anywhere !important;
  vertical-align: top !important;
  line-height: 1.2;
}

/* slightly tighter desktop density */
.table thead th{ padding: 8px 8px !important; }
.table tbody td{ padding: 10px 8px !important; font-size: 12.5px !important; }
.head-row th{ font-size: 11.5px !important; }

/* filter inputs remain compact */
.table thead input{
  height: 32px !important;
  font-size: 12px !important;
  padding: 0 10px !important;
}

/* DENSER GRID: reduce spacing so the table fits */
.table thead th{
  padding: 6px 6px !important;
}

.table tbody td{
  padding: 8px 6px !important;
  font-size: 12px !important;
}

/* make headers smaller */
.head-row th{
  font-size: 11px !important;
}

/* make filter row slimmer */
.table thead input{
  height: 30px !important;
  padding: 0 8px !important;
  border-radius: 10px !important;
  font-size: 12px !important;
}

/* ensure the table doesn't exceed the card */
.table-wrap .table{
  width: 100% !important;
  min-width: 0 !important;
  table-layout: fixed !important;
}

/* =========================
   TABLE SECTION (NO CARD)
   ========================= */
   .table-section{
  background: transparent;
  margin-top: 8px;
}
  .no-access{
    margin: 16px 0;
    padding: 12px;
    border-radius: 10px;
    border: 1px solid #f3c7c7;
    background: #fff3f3;
    color: #9b1c1c;
    font-weight: 700;
  }

/* Header above the table */
.table-head{
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px 4px;
  border-bottom: 1px solid var(--border);
}

.table-head h3{
  margin: 0;
  font-size: 15px;
  font-weight: 900;
}

.meta{
  display: flex;
  gap: 8px;
}

/* Ensure NOTHING clips the table */
.table-wrap{
  overflow: visible !important;
  max-width: 100%;
}

/* Table must fully fit viewport */
.table{
  width: 100%;
  min-width: 0 !important;
  table-layout: fixed;
}

/* Final safety net against clipping */
.table th,
.table td{
  overflow: visible !important;
}

/* Give engine serial (Serie) more space */
.table th:nth-child(5),
.table td:nth-child(5){
  width: 220px;
  white-space: nowrap;   /* keep serial on one line */
}

</style>

  <script>
  import axios from 'axios';
  import Swal from 'sweetalert2';
  
  export default {
      data() {
          return {
              permissions: [],
              currentPage: 1,
              pageSize: 12,
              units : [],
              n_units: 0,
              filters: {
                  unit_id: '',
                  unit_short_id: '',
                  unit_owner: '',
                  unit_plates: '',
                  unit_engine_num: '',
                  unit_brand: '',
                  unit_sub_brand: '',
                  unit_model: '',
                  unit_class: '',
                  unit_type: '',
                  unit_category: '',
                  unit_status: ''
              },
              originalUnits: []
          }
      },
      computed: {
          paginatedUnits() {
              return this.units
          },
          totalUnitsPages() {
              return Math.ceil(this.n_units / this.pageSize);
          },
          canViewTable() {
              return this.hasAnyPerm(['maintenance.view_unit_table', 'ui_access_units_table']);
          },
          canCreateUnit() {
              return this.hasAnyPerm(['maintenance.create_unit', 'ui_access_units_create']);
          },
          canViewUnit() {
              return this.hasAnyPerm(['maintenance.view_unit', 'ui_access_units_view']);
          },
      },
      mounted() {
          this.loadPermissions();
          this.fetchUnits();
      },
      methods: {
          loadPermissions() {
              try {
                  this.permissions = JSON.parse(localStorage.getItem('userPermissions')) || [];
              } catch (error) {
                  this.permissions = [];
              }
          },
          hasPerm(perm) {
              if (!perm) return false;
              if (this.permissions.includes(perm)) return true;
              return this.permissions.includes(`access_control.${perm}`);
          },
          hasAnyPerm(perms) {
              if (!Array.isArray(perms) || perms.length === 0) return false;
              return perms.some((perm) => this.hasPerm(perm));
          },
          backMainPanel() {
              window.location.href = '/main-panel';
          },
          addUnit() {
              window.location.href = '/agregar-nueva-unidad';
          },
          goToPage(pageNumber) {
              this.currentPage = pageNumber;
              const page = this.currentPage
              this.fetchUnits(page);
          },
          async fetchUnits(page = 1) {
              let response
              const apiDirectory = process.env.API_DIRECTORY;
  
              try {
                  if (!this.canViewTable) {
                      return;
                  }
                  response = await axios.post(`${apiDirectory}/get-unit?page=${page}&page_size=${this.pageSize}`,this.filters)
                  const responseData = response.data.results;
                  this.units = responseData
                  this.n_units = response.data.count
                  this.originalUnits = [...responseData]
              }
              catch (error) {
                  console.error('Error fetching data from API:', error)
              }
          },
          nextPage() {
              if (this.currentPage < this.totalUnitsPages) this.currentPage++;
              const page = this.currentPage
              this.fetchUnits(page);
          },
          prevPage() {
              if (this.currentPage > 1) this.currentPage--;
              const page = this.currentPage
              this.fetchUnits(page);
          },
          applyFiltersUnit() {
              this.fetchUnits()
          },
          viewUnitDetails(unit_id) {
              if (!this.canViewUnit) {
                  Swal.fire('Sin acceso', 'No tienes permisos para ver detalles.', 'warning');
                  return;
              }
              Swal.fire({
                  title: '¿Estás seguro?',
                  text: `¿Quieres ver los detalles de la unidad con el ID ${unit_id}?`,
                  icon: 'question',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Sí, ver detalles',
                  cancelButtonText: 'No, cancelar'
              }).then((result) => {
                  if (result.isConfirmed) {
                      this.$router.push({ name: 'EditUnitProfile', params: { unit_id } });
                  }
              });
          },
      }
  }
  </script>
